import { useMemo } from 'react';

import type { TimelineData, TimelineHighlight } from '@revelio/replots';

import { useTableRowsExport } from '../chart-menu/ChartMenuContext';
import { useSubsidiaryYearHighlight } from '../SubsidiaryTrend/subsidiary-year-highlight';

export const useLineageYearHighlight = (
  rcid: number
): TimelineHighlight | null => {
  const yearHighlight = useSubsidiaryYearHighlight(rcid);
  return useMemo(
    () =>
      yearHighlight === null
        ? null
        : {
            ids: yearHighlight.ids,
            leftIds: yearHighlight.leftIds,
            from: yearHighlight.from,
            to: yearHighlight.to,
          },
    [yearHighlight]
  );
};

export const useLineageExport = (data: TimelineData) => {
  const rows = useMemo(
    () =>
      data.entities.map((entity) => ({
        Company: entity.label ?? entity.id,
        RCID: entity.id,
        Parent: entity.parentId ?? '',
        Joined: entity.joinedAt ?? '',
        Left: entity.endedAt ?? '',
        Employees: entity.value ?? 0,
      })),
    [data]
  );
  useTableRowsExport(rows);
};
